// FT-170 STEP-12. Чистые функции отслеживания несохранённых изменений —
// без Vue и без $store, чтобы снимок/сравнение можно было проверить юнит-
// тестом без монтирования компонента. Единственный текущий потребитель —
// CompanyProfile.vue (beforeRouteLeave, CTR-07): у компонента ~7000 строк,
// полный mount под каждый сценарий непропорционален.
//
// Поля задаются перечнем путей вида "company.name" или "clients_sources"
// (один уровень точки — этого достаточно для карты CompanyProfile.vue,
// глубже вложенность там не встречается).
function getPath(obj, path) {
  return path.split(".").reduce((acc, key) => (acc == null ? acc : acc[key]), obj);
}

// Снимок только перечисленных полей, глубокая копия через JSON round-trip:
// дешёво, покрывает скаляры, массивы (clients_sources) и плоские объекты —
// отдельной зависимости ради единственного use-case не тянем.
export function snapshot(obj, fields) {
  const result = {};
  fields.forEach((field) => {
    const value = getPath(obj, field);
    // JSON.stringify(undefined) возвращает JS-значение undefined (не строку) —
    // JSON.parse(undefined) падает (String(undefined) не валидный JSON). Поле
    // ещё не пришло с сервера (объект компании догружается по частям) — не
    // повод ронять снимок, undefined и остаётся undefined.
    result[field] = value === undefined ? undefined : JSON.parse(JSON.stringify(value));
  });
  return result;
}

// Сравнение по тому же перечню полей, что и снимок: список могли расширить
// уже после snapshot(), поэтому перебираем fields, а не ключи snap.
export function isDirty(obj, snap, fields) {
  if (!snap) return false;
  return fields.some((field) => {
    const current = JSON.stringify(getPath(obj, field));
    const saved = JSON.stringify(snap[field]);
    return current !== saved;
  });
}

// Решение beforeRouteLeave вынесено в чистую функцию: реальный хук в
// CompanyProfile.vue — короткий делегат, и мутация «снять guard» (CHK-07)
// валится уже на этом уровне, без монтирования компонента.
// confirmFn может вернуть Promise (стандартный диалог $confirm) — роутер ждёт next сколько нужно.
// Ошибка диалога — остаёмся на странице: данные дороже перехода.
export function confirmLeave({ dirty, confirmFn, next }) {
  if (!dirty) {
    next();
    return Promise.resolve();
  }
  return Promise.resolve()
    .then(() => confirmFn())
    .then((ok) => (ok ? next() : next(false)), () => next(false));
}
